import { MapPin, ShoppingBag, ArrowDown } from "lucide-react";
import { CAFE, IMAGES, isOpenNow } from "../data/cafeData";

export const Hero = () => {
  const open = isOpenNow();

  return (
    <section id="home" data-testid="hero-section" className="grain-overlay relative flex min-h-screen items-end overflow-hidden">
      <img
        src={IMAGES.hero}
        alt="Barista pouring latte art at Nomad Cafe"
        className="absolute inset-0 h-full w-full object-cover object-[50%_68%]"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#21150C] via-[#21150C]/55 to-[#21150C]/20" />

      <div className="relative z-10 mx-auto w-full max-w-6xl px-5 pb-20 pt-40 md:px-8 md:pb-28">
        <div className="animate-fade-up" style={{ animationDelay: "0.1s" }}>
          <span
            data-testid="hero-open-badge"
            className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 font-accent text-xs font-semibold uppercase tracking-[0.2em] backdrop-blur-sm ${
              open
                ? "border-[#6E7E65]/60 bg-[#6E7E65]/25 text-[#DDE8D5]"
                : "border-[#C86D51]/60 bg-[#C86D51]/25 text-[#F3CDBD]"
            }`}
          >
            <span className={`h-1.5 w-1.5 rounded-full ${open ? "bg-[#A9C29A]" : "bg-[#E8A08A]"}`} />
            {open ? "Open now in Royal Vista" : "Currently closed"}
          </span>
        </div>

        <h1
          data-testid="hero-headline"
          className="animate-fade-up mt-6 max-w-3xl font-serif text-4xl font-bold leading-[1.05] tracking-tight text-[#FDFBF7] sm:text-5xl lg:text-6xl"
          style={{ animationDelay: "0.25s" }}
        >
          Where YYC wanders,
          <br />
          <em className="font-medium italic text-[#E9C9A8]">the brews follow.</em>
        </h1>

        <p
          data-testid="hero-subtext"
          className="animate-fade-up mt-6 max-w-xl text-base leading-relaxed text-[#FDFBF7]/85 md:text-lg"
          style={{ animationDelay: "0.4s" }}
        >
          A nomadic sanctuary in northwest Calgary pouring house specialty lattes,
          ceremonial matcha, and fresh waffles — from sunrise regulars to evening wanderers.
        </p>

        <div className="animate-fade-up mt-9 flex flex-wrap items-center gap-4" style={{ animationDelay: "0.55s" }}>
          <span
            data-testid="hero-order-button"
            className="flex cursor-not-allowed items-center gap-2.5 rounded-full bg-[#6E5E53]/70 px-7 py-3.5 font-accent text-sm font-semibold text-[#FDFBF7]/70 backdrop-blur-sm select-none"
            title="Online ordering is coming soon"
          >
            <ShoppingBag size={16} />
            Online Ordering · Coming Soon
          </span>
          <a
            href="#menu"
            data-testid="hero-menu-button"
            className="flex items-center gap-2.5 rounded-full bg-[#C86D51] px-7 py-3.5 font-accent text-sm font-semibold text-[#FDFBF7] shadow-lg shadow-[#C86D51]/25 transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#B35B40]"
          >
            Explore the Menu
          </a>
        </div>

        <div
          className="animate-fade-up mt-12 flex items-center gap-2 text-sm text-[#FDFBF7]/70"
          style={{ animationDelay: "0.7s" }}
        >
          <MapPin size={15} className="text-[#D49B4B]" />
          <span>{CAFE.address}, {CAFE.addressCity}</span>
        </div>
      </div>

      <div className="absolute bottom-6 right-8 z-10 hidden md:block">
        <ArrowDown size={20} className="animate-bounce text-[#FDFBF7]/60" />
      </div>
    </section>
  );
};
